"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeBannerComponent = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var bannerimg_png_1 = __importDefault(require("../../../../assets/WebAssets/bannerimg.png"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var home_1 = require("../../../../api/calls/site_content/home");
var HomeBannerComponent = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(function () { }, []);
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)(""), timeOfDay = _a[0], setTimeOfDay = _a[1];
    var _b = (0, react_1.useState)({}), homeContent = _b[0], setHomeContent = _b[1];
    (0, react_1.useEffect)(function () {
        var currentTime = new Date().getHours();
        if (currentTime >= 0 && currentTime < 12) {
            setTimeOfDay("Morning");
        }
        else if (currentTime >= 12 && currentTime < 17) {
            setTimeOfDay("Afternoon");
        }
        else if (currentTime >= 17 && currentTime < 24) {
            setTimeOfDay("Evening");
        }
    }, []);
    (0, react_1.useEffect)(function () {
        (0, home_1.getHomeContent)().then(function (response) {
            var _a;
            if (response.success) {
                (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.forEach(function (doc) {
                    var providerData = doc.data();
                    setHomeContent(providerData);
                });
            }
            else {
            }
        });
    }, []);
    return (react_1.default.createElement("div", { className: "flex flex-col relative items-start px-0 h-[450px] " },
        react_1.default.createElement("img", { className: "h-full w-full object-cover absolute rounded-3xl -z-20", src: bannerimg_png_1.default }),
        react_1.default.createElement("div", { className: "flex flex-col justify-center items-start h-full -z-10 pb-10 px-2 gap-4 pl-5 lg:pl-20" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Good ".concat(timeOfDay, ","), size: "medium", textColor: "text-tertiary" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: user === null || user === void 0 ? void 0 : user.name, size: "medium", textColor: "text-tertiary", bold: true })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Bravo! You've reached your Tech Gateway!", size: "4xlarge", textColor: "text-tertiary" })))));
};
exports.HomeBannerComponent = HomeBannerComponent;
